import { commonTypes } from '../common';

export const initialState = {
  deviceInfo: {
    color: null,
    fundingOfferInfo: null,
    isPrePurchase: false,
    mobileInsurance: null,
    name: null,
    pacPrice: null,
  },
};

const UINeedsTerminalDataReducer = (state, action) => {
  switch (action.type) {
    case commonTypes.SET_TERMINAL_INFO: {
      const {
        name, fundingOfferInfo, color, storage, clientPrice, isPrePurchase, tradeIn, pricesInfo, swap, 
        swapRenewalPeriod,
      } = action.payload;
      
      let newState;

      if(pricesInfo){
        const {
          recurringCharges,
          oneTimeCharges,
          termsAndConditions,
          taxName,
          haveMaintainingPromo,
        } = pricesInfo;
        newState = {
          ...state,
          deviceInfo: {
            ...state.deviceInfo,
            name,
            fundingOfferInfo,
            color,
            storage,
            pacPrice: clientPrice,
            isPrePurchase,
            tradeIn,
            swap,
            swapRenewalPeriod,
          },
          pricesInfo: {
            recurringCharges,
            oneTimeCharges,
            taxName,
            haveMaintainingPromo
          },
          legalTerms: {
            termsAndConditions,
          },
        };
      } else {
        newState = {
          ...state,
          deviceInfo: {
            ...state.deviceInfo,
            swap,
            name,
            fundingOfferInfo,
            color,
            storage,
            pacPrice: clientPrice,
            isPrePurchase,
            tradeIn,
            swapRenewalPeriod,
          },
        };
      }

      return {
        state: newState,
        stepsMustBeEvaluated: pricesInfo ? true : false,
      };
    }
    case commonTypes.SET_VTL_DATA_FOR_CONFIRMATION: {
      const { vtlDataForConfirmation } = action.payload;
      const { terminalData } = vtlDataForConfirmation;
      const newState = {
        ...state,
        deviceInfo: {
          ...state.deviceInfo,
          tradeIn: terminalData.tradeIn,
        },
      };

      return {
        state: newState,
        stepsMustBeEvaluated: false,
      };
    }
    default:
      return null;
  }
};

export const actions = {

};

export default UINeedsTerminalDataReducer;
